import { z } from "zod";

export const BufferTimesSchema = z.object({
  preparationTime: z.number().int().nonnegative(), // <-- in Minutes
  wrapUpTime: z.number().int().nonnegative(), // <-- in Minutes
});

export type BufferTimes = z.infer<typeof BufferTimesSchema>;
